import Bitmap from "../../bitmap";
import Color from "../../models/color";
import { IBlockPack } from "./IBlockPack";
import { calculateBorderWidth } from "./utils/borderUtils";

export abstract class BaseBlockPack implements IBlockPack {
  abstract drawBlock(
    bit: Bitmap,
    x: number,
    y: number,
    side: number,
    width: number,
    color: Color,
    to: number[]
  ): void;

  /**
   * Gets the border width for this pack style
   */
  protected getBorderWidth(width: number): number {
    return calculateBorderWidth(width, this.getBorderStyle());
  }

  /**
   * Gets the border style (default or thick)
   */
  protected getBorderStyle(): 'default' | 'thick' {
    return 'default';
  }

  /**
   * Draws the main block body (fill area)
   */
  protected drawBlockFill(
    bit: Bitmap,
    x: number,
    y: number,
    width: number,
    height: number,
    color: Color
  ): void {
    bit.drawShape([
      x, y,
      x + width, y,
      x + width, y + height,
      x, y + height
    ], color.shade(4));
  }

  /**
   * Draws corner connections between adjacent blocks
   */
  protected drawBlockCorner(
    bit: Bitmap,
    x: number,
    y: number,
    side: number,
    width: number,
    borderWidth: number,
    color: Color,
    to: number[]
  ): void {
    // Top-left corner connection
    if (!(side & 1) && !(side & 2) && to[0] & 2 && to[1] & 1) {
      bit.drawShape([
        x, y,
        x + borderWidth, y + borderWidth,
        x + borderWidth, y
      ], color.shade(5));
      bit.drawShape([
        x, y,
        x + borderWidth, y + borderWidth,
        x, y + borderWidth
      ], color.shade(5));
    }
    
    // Top-right corner connection
    if (!(side & 4) && !(side & 2) && to[2] & 2 && to[1] & 4) {
      bit.drawShape([
        x + width - borderWidth, y,
        x + width - borderWidth, y + borderWidth,
        x + width, y
      ], color.shade(3));
      bit.drawShape([
        x + width, y,
        x + width, y + borderWidth,
        x + width - borderWidth, y + borderWidth
      ], color.shade(5));
    }
    
    // Bottom-left corner connection
    if (!(side & 1) && !(side & 8) && to[0] & 8 && to[3] & 1) {
      bit.drawShape([
        x, y + width,
        x + borderWidth, y + width - borderWidth,
        x, y + width - borderWidth
      ], color.shade(3));
      bit.drawShape([
        x, y + width,
        x + borderWidth, y + width - borderWidth,
        x + borderWidth, y + width
      ], color.shade(5));
    }
    
    // Bottom-right corner connection
    if (!(side & 4) && !(side & 8) && to[2] & 8 && to[3] & 4) {
      bit.drawShape([
        x + width, y + width,
        x + width, y + width - borderWidth,
        x + width - borderWidth, y + width - borderWidth
      ], color.shade(3));
      bit.drawShape([
        x + width, y + width,
        x + width - borderWidth, y + width,
        x + width - borderWidth, y + width - borderWidth
      ], color.shade(3));
    }
  }
}

